/**
 * 友好的时间显示
 * @param { string | number } time 时间戳 或 标准时间格式, 例如 2020-04-27T17:40:26Z
 * @return { string }
 * @author Jianbo
*/
export const timeFormater = function (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
    if (!date) {
        return ''
    }
    date = new Date(date)

    var o = {
        'M+': date.getMonth() + 1,
        'D+': date.getDate(),
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
    }
    var week = {
        '0': '\u65e5',
        '1': '\u4e00',
        '2': '\u4e8c',
        '3': '\u4e09',
        '4': '\u56db',
        '5': '\u4e94',
        '6': '\u516d'
    }
    if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt
}


export const friendlyTime = function (time) {
    const now = new Date()
    const date = (typeof time === 'number') ? (time > 10e10 ? new Date(time) : new Date(time * 1000)) : new Date(time || '')

    const diff = ((now.getTime() - date.getTime()) / 1000) // 时间差

    if (diff < 0) diff = 0 // 处理未来时间

    const dayDiff = diff > 86400 && (now.getDate() - date.getDate() > 0) ? Math.floor(diff / 86400) : 0
    const yearDiff = now.getFullYear() - date.getFullYear()

    const isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())

    if (!isValidDate) {
        return null
    }
    return dayDiff === 0 && `今天 ${timeFormater(date, 'HH:mm:ss')}` || dayDiff <= 2 && (
        dayDiff === 1 && `昨天 ${timeFormater(date, 'HH:mm')}` ||
        dayDiff === 2 && `前天 ${timeFormater(date, 'HH:mm')}`
    ) || (
            yearDiff < 1 && `${timeFormater(date, 'MM-DD HH:mm')}` ||
            timeFormater(date, 'YYYY-MM-DD HH:mm')
        )
}


export const addImageSuffix = (src, suffix = 'large') => {
    let image = src
  
    if (image && image.indexOf('wanfangche.com') >= 0) {
      let [url] = image.split('?')
      image = url + '?x-oss-process=style/' + suffix
    }
  
    return image
  }
  

export default { friendlyTime, addImageSuffix }